import React, { useState } from "react";
import { Clock } from "lucide-react";
import { Popover, PopoverTrigger, PopoverContent } from "@/components/ui/popover";
import { useApp } from "@/context/AppContext";

const HOURS = Array.from({ length: 24 }, (_, i) => String(i).padStart(2, "0"));
const MINS = ["00", "15", "30", "45"];

export default function TimePicker({ value, onChange, placeholder, testid }) {
  const { t } = useApp();
  const [open, setOpen] = useState(false);
  const [h, m] = (value || "").split(":");
  const pick = (hh, mm) => { onChange(`${hh}:${mm}`); if (mm !== undefined && hh !== undefined) setOpen(false); };
  return (
    <Popover open={open} onOpenChange={setOpen}>
      <PopoverTrigger asChild>
        <button type="button" className={`gg-input flex items-center justify-between gap-2 text-left ${value ? "" : "text-muted-foreground"}`} data-testid={testid}>
          <span className="font-display uppercase tracking-wide">{value || placeholder || "—"}</span>
          <Clock className="w-4 h-4 text-primary shrink-0" />
        </button>
      </PopoverTrigger>
      <PopoverContent align="start" className="w-auto p-3 border border-foreground rounded-none bg-background shadow-none" data-testid={`${testid}-popover`}>
        <div className="flex gap-3">
          <div>
            <div className="eyebrow !text-[10px] text-muted-foreground mb-1.5">{t("hour")}</div>
            <div className="grid grid-cols-6 gap-px">
              {HOURS.map(x => <button key={x} type="button" onClick={() => pick(x, m || "00")} className={`w-9 h-8 font-display text-sm hover:bg-muted transition-colors ${h === x ? "bg-primary text-primary-foreground" : ""}`} data-testid={`${testid}-h-${x}`}>{x}</button>)}
            </div>
          </div>
          <div className="border-l border-foreground/30 pl-3">
            <div className="eyebrow !text-[10px] text-muted-foreground mb-1.5">{t("minute")}</div>
            <div className="grid grid-cols-1 gap-px">
              {MINS.map(x => <button key={x} type="button" onClick={() => pick(h || "20", x)} className={`w-10 h-8 font-display text-sm hover:bg-muted transition-colors ${m === x ? "bg-primary text-primary-foreground" : ""}`} data-testid={`${testid}-m-${x}`}>{x}</button>)}
            </div>
          </div>
        </div>
        {value && <button type="button" onClick={() => { onChange(""); setOpen(false); }} className="eyebrow mt-2 hover:text-primary" data-testid={`${testid}-clear`}>×</button>}
      </PopoverContent>
    </Popover>
  );
}
